export default
{
    path: '/navPage',
    name: 'navPage',
    component: () => import('../views/main/index.vue'),
}